module.exports = __webpack_public_path__ + "img/qianbao.ff6e2382.png";